export const TRANSFER_INBOUND = ['TRANSFER_INBOUND'];

export const TRANSFER_INBOUND_TASK = (sign_no: string) => [
  ...TRANSFER_INBOUND,
  sign_no,
];
